"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.playerGridWrapperStyles = exports.VIDEO_SPACING = void 0;
exports.VIDEO_SPACING = 16;
exports.playerGridWrapperStyles = {
    root: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap",
        gap: `${exports.VIDEO_SPACING}px`,
        "@media only screen and (min-width: 769px)": {
            width: "100%",
            height: "inherit",
        },
        "@media only screen and (max-width: 770px)": {
            width: "inherit",
            height: "100%",
        },
    },
};
//# sourceMappingURL=styles.js.map